import React from "react";
import HomeView from "./HomeView";

export function HomeContainer() {
  return <HomeView title="Home" />;
}
